<ng-template #tplDataInvalid>
  {{'form.validator.data_invalid'|translate}}
</ng-template>
<form *ngIf="is_ready && sentSmsForm" [formGroup]="sentSmsForm" (ngSubmit)="submit()">
  <div fxLayout="column">
    <div>
      <mat-form-field class="full-width">
        <mat-label>{{'sms.sender'|translate}}</mat-label>
        <mat-select [placeholder]="'sms.sender' | translate" formControlName="sender" [disabled]="!didOptionList.length"
          [matTooltip]="!didOptionList.length ? ('sms.no_sms_enabled_number'|translate) : ''">
          <mat-option *ngFor="let did of didOptionList" [value]="did.number">
            {{ did.display_number }}
          </mat-option>
        </mat-select>
        <button mat-icon-button matSuffix (click)="clearControl('sender', $event)"
          [disabled]="!sentSmsForm.get('sender').value">
          <mat-icon>close</mat-icon>
        </button>

        <mat-error *ngIf="sentSmsForm.get('sender').invalid && sentSmsForm.get('sender').touched"
          [flexFormControlError]="sentSmsForm.get('sender')" [customMessages]="{
          sender_required: 'send_sms.message.sender_or_sender_name_not_empty'|translate
        }"></mat-error>
      </mat-form-field>
    </div>

    <div>
      <mat-form-field class="full-width">
        <mat-label>{{'sms.sms_template'|translate}}</mat-label>
        <mat-select [placeholder]="'sms.sms_template' | translate" formControlName="sms_template"
          [disabled]="!smsTemplateList.length"
          [matTooltip]="!smsTemplateList.length ? ('sms.no_sms_template_item'|translate) : ''">
          <mat-option *ngFor="let smsTemplate of smsTemplateList" [value]="smsTemplate">
            {{ smsTemplate.name }}
          </mat-option>
        </mat-select>
        <button mat-icon-button matSuffix (click)="clearControl('sms_template', $event)"
          [disabled]="!sentSmsForm.get('sms_template').value">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="full-width">
        <mat-label>{{'sms.sender_name'|translate}}</mat-label>
        <input matInput [placeholder]="'sms.sender_name' | translate" formControlName="sender_name">
        <button mat-icon-button matSuffix (click)="clearControl('sender_name', $event)"
          [disabled]="!sentSmsForm.get('sender_name').value">
          <mat-icon>close</mat-icon>
        </button>

        <mat-error *ngIf="sentSmsForm.get('sender_name').invalid && sentSmsForm.get('sender_name').touched"
          [flexFormControlError]="sentSmsForm.get('sender_name')" [customMessages]="{
          pattern: 'sms_template.validator.sender_name_incorrect'|translate,
          maxlength: 'form.validator.max_length' | translate:{ max:
            sentSmsForm.get('sender_name').errors?.maxlength?.requiredLength
          },
          sender_required: 'send_sms.message.sender_or_sender_name_not_empty'|translate,
          ascii: 'send_sms.message.ascii_only_accepted'|translate,
          isPhoneNumber: 'send_sms.message.phone_number_not_accepted'|translate
        }"></mat-error>

      </mat-form-field>
    </div>

    <div>
      <mat-form-field class="full-width">
        <mat-label>{{'sms.destination'|translate}}</mat-label>
        <input matInput [placeholder]="'sms.destination' | translate" formControlName="destination">
        <mat-hint>{{ 'sms.content.hint_destination'|translate }}</mat-hint>
        <button mat-icon-button matSuffix (click)="clearControl('destination', $event)"
          [disabled]="!sentSmsForm.get('destination').value">
          <mat-icon>close</mat-icon>
        </button>

        <mat-error *ngIf="sentSmsForm.get('destination').invalid && sentSmsForm.get('destination').touched"
          [flexFormControlError]="sentSmsForm.get('destination')" [customMessages]="{
          destination: 'sms.alert.destination_blank'|translate,
          maxlength: 'did.content.phone_number_maxlength'|translate: { max: 20 },
          invalidPhoneNumber: 'form.validator.data_invalid'|translate
        }"></mat-error>
        
      </mat-form-field>
    </div>
    <div>
      <mat-form-field class="full-width">
        <mat-label>{{'sms.message'|translate}}</mat-label>
        <textarea (keydown)="handleKeyboardEvent($event)"
          [maxlength]="hasLimitedSms() && smsContentInfo && (smsContentInfo.max+1) || smsMaxLength" matInput
          cdkTextareaAutosize cdkAutosizeMinRows="5" cdkAutosizeMaxRows="10" [placeholder]="'sms.message' | translate"
          formControlName="message"></textarea>

        <mat-hint *ngIf="smsContentInfo" align="end">
          <span *ngIf="hasLimitedSms();else CountSMS">{{ smsContentInfo.length || 0 }}/{{ smsContentInfo.max }}</span>
          <ng-template #CountSMS>{{ 'sms.content.frag'|translate }} {{ smsContentInfo.frag }}</ng-template>
        </mat-hint>

        <mat-error *ngIf="sentSmsForm.get('message').invalid && sentSmsForm.get('message').touched"
          [flexFormControlError]="sentSmsForm.get('message')" [customMessages]="{
          smsMax: 'form.validator.max_length' | translate:{ max: sentSmsForm.get('message').errors?.smsMax?.requiredLength }
        }"></mat-error>
        
      </mat-form-field>
    </div>
  </div>
</form>
